import React     from 'react';
import PropTypes from 'prop-types';
import Flux      from '../../../flux/Flux';
import {getCurrencyIcon} from '../../../utils/CommonUtils.js';

const OfferIcon = (props) => {
	const {offer, purchased} = props;
	const {offers}           = Flux.Constants.DailyBonuses;
	const classes            = ['icon-365', 'icon'];

	switch (offer) {
		case offers.VIP:
			classes.push(Flux.Guest.isVip() ? '-icon-image-full' : '-icon-person-vip');
			break;

		case offers.VIDEO:
			classes.push('-icon-videotake-full');
			break;

		case offers.VIDEO_VOUCHER:
			classes.push('-icon-voucher-icon');
			break;

		case offers.PHOTO_ALBUM:
			classes.push('-icon-image-album-lite');
			break;

		case offers.TOP_UP_PERCENT:
			classes.push('-icon-merchandise-sale-lite');
			break;

		case offers.TOP_UP_FLAT:
			classes.push(getCurrencyIcon());
			break;

		case offers.MERCHANDISE:
			classes.push('-icon-merchandise-sale-lite');
			break;

		case offers.MESSENGER_GIFT:
			classes.push('-icon-gift-line');
			break;

		default:
	}

	if (purchased) {
		classes.push('-icon-arrow-animated');
	}

	return <i className={classes.join(' ')} />;
};

OfferIcon.propTypes = {
	offer:     PropTypes.string,
	purchased: PropTypes.bool,
};

OfferIcon.defaultProps = {
	purchased: false,
};

export default OfferIcon;
